/**
 * Contains notification message localized strings
 *
 * @type {{copyWatchlistSucceeded: string; copyWatchlistFailed: string}}
 */
export const notificationMessages = {
  copyWatchlistSucceeded: $localize`:|import watchlist from snapshot detail page succeeded @@watchlist-snapshot-detail-page.component_import-succeeded:The watchlist <b>$WATCHLIST_NAME$</b> has been copied to your lists.`,
  copyWatchlistFailed: $localize`:|import watchlist from snapshot detail page failed @@watchlist-snapshot-detail-page.component_import-failed:The watchlist <b>$WATCHLIST_NAME$</b> could not be created to your list.`
};
